 
 
 
 
 
 
define(['http', 'security', './utils', 'endpoints'],
    function(http, security, utils, endpoints) {
        'use strict';
        return {
            trafficViewport: function(options, callback) {
                var pathParams = {};
                var queryParams = {};
                queryParams.key = utils.or(options.key, security.getKey('services/traffic'));
                http.get({
                    url: '{protocol}://' + endpoints.trafficViewport,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callback: callback,
                    fail: options.fail
                });
            }
        };
    }
);



// WEBPACK FOOTER //
// ./rest/trafficViewport.js